import { useEffect, useState } from 'react';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../../hooks/useLoadData';
import { useSaveData } from '../../../../hooks/useSaveData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './customer-contacts-columns';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';

interface ProjectsTabProps {
  unitID: number;
}
export const CustomerDetailsTab = ({ unitID }: ProjectsTabProps) => {

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('UnitDetailContact', 'UnitDetailContact')
  );

  const { isLoading, data: UnitDetailContacts, refetch } = useLoadData<ApiResponse<any[]>>(contactApiKeyStore.getUnitContacts(unitID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnitDetailContacts, setFilteredUnitDetailContacts] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitDetailContactList = UnitDetailContacts?.data?.filter((UnitDetailContact) =>
      Object.values(UnitDetailContact).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnitDetailContacts(filteredUnitDetailContactList || []);
  }, [debouncedSearchTerm, UnitDetailContacts?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'UnitDetailContact',
      pageName: 'UnitDetailContact',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'UnitDetailContact',
      pageName: 'UnitDetailContact',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      if (filterData && columnJson) {
        setGridConfig({
          columns: columnJson,
          dataState: filterData,
        });
      }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  return (
    <SiTrackGrid
      fileTitle='unit_contact'
      columns={columns}
      dataItemKey="contactsID"
      // queryConfig={contactApiKeyStore.getUnitContacts(unitID)}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      isBusy={isLoading || isLoadingGridLayout}

      // -----------------Grid Layout-------
      dataItems={filteredUnitDetailContacts || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
